module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_9005.2a595e3f.png";